export default __webpack_public_path__ + "media/images/elephant_ui_disappointed-8864342480c3612e3061702851d3a798.svg";